<div class="simple-notification">
  <span class="simple-notification__text">{{data.message.text}}</span>
  <div>
    <button mat-button color="primary" (click)="action()">
      {{data.action?.name | uppercase}}
    </button>
  </div>
  <div>
    <mat-icon *ngIf="!!data.action && data.action.type === 0" (click)="dismiss()">close</mat-icon>
  </div>
</div>
